(function(){
  'use strict'; // opt out of "sloppy mode" this is only applyed to this function however so will not break other code

  angular
    .module('iqxCore')
    .controller('SettingsCtrl', UserSettingsCtrl)
  
  function UserSettingsCtrl($scope, $timeout, ApplicationSvc, SweetAlert) {
    var userSettings = this

    userSettings.viewTab = viewTab
    userSettings.activeTab = {}
    userSettings.tabs = []

    $timeout(activate, 300)

    ///////////

    function activate(){
      // add tabs {url:"", name:""}
      userSettings.tabs.push({url:"views/settings.account.html", name:"Account"})
      if ($scope.params['FB_MSGSENDERID'] && $scope.params['FB_MSGSENDERID'] !==''){ // simple check to ensure message senderID is there.
        userSettings.tabs.push({url:"views/settings.devices.html", name:"Notification Devices"})
      }
      userSettings.tabs.push({url:"views/settings.accessibility.html", name:"Accessibility"})
      viewTab(userSettings.tabs[0])
    }

  
    function viewTab(tab){
      userSettings.activeTab = tab
    }
  }
})()
